import { Predicate, Predicates } from '../../ng/components/validation'

// this module exists to provide an interface and runtime validation of current-organization props
// provided in angularjs templates and react bridge components
export interface CurrentOrganization {
  organizationUuid: string
  isFreemium: boolean
}

export const isCurrentOrganization: Predicate<CurrentOrganization> =
  Predicates.hasShape({
    organizationUuid: Predicates.isString,
    isFreemium: Predicates.isBoolean
  })
